export type InactiveProResumeNudgeVariant =
  | 'inactive_pro'
  | 'grant_expiring'
  | 'scheduled_cancel';

const storageKey = (orgId: string, variant: InactiveProResumeNudgeVariant) =>
  `bd.inactiveProResume.dismissed:${variant}:${orgId}`;

export function isInactiveProResumeNudgeDismissed(
  orgId: string,
  variant: InactiveProResumeNudgeVariant
): boolean {
  try {
    return window.sessionStorage.getItem(storageKey(orgId, variant)) === '1';
  } catch {
    return false;
  }
}

export function dismissInactiveProResumeNudge(
  orgId: string,
  variant: InactiveProResumeNudgeVariant
): void {
  try {
    window.sessionStorage.setItem(storageKey(orgId, variant), '1');
  } catch {
    // Safari private mode, etc.
  }
}
